var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48269 0C1.12144 0 0 1.12169 0 2.48269V13.5173C0 14.8784 1.12169 16 2.48269 16H20.6898C22.0511 16 23.1725 14.8783 23.1725 13.5173V2.48269C23.1725 1.12164 22.0508 0 20.6898 0H2.48269ZM2.66377 1.65529H20.5177L12.0949 9.17263C11.7738 9.45934 11.4168 9.45954 11.0949 9.17263L2.66372 1.6548L2.66377 1.65529ZM1.65504 2.97417L7.32752 8.03434L1.65504 13.4827V2.97417ZM21.5174 2.97417V13.4743L15.8621 8.02596L21.5174 2.97417ZM14.6207 9.1378L20.0262 14.3448H3.14668L8.56891 9.14666L9.99135 10.414C10.8955 11.2203 12.2939 11.2215 13.1984 10.414L14.621 9.13804L14.6207 9.1378Z",
    fill: "white"
  })));
};
export default SvgMail;